interface State {
  current_date: string
  entries: any
  keys: any[]
  type: string
}

const defaultState = Object.assign(
  {
    current_date: '',
    entries: {},
    keys: [],
    type: ''
  },
  {}
)

const state: State = Object.assign({}, defaultState)

const mutations = {
  resetState(state: State) {
    const s = defaultState
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },

  setCurrentDate(state: State, current_date: '') {
    state.current_date = current_date
  },
  setEntries(state: State, entries: {}) {
    state.entries = entries
  },
  setKeys(state: State, keys: any[]) {
    state.keys = keys
  },
  setType(state: State, type: string) {
    state.type = type
  }
}

const actions = {}

const getters = {
  current_date: (state: State): {} => state.current_date,
  entries: (state: State): {} => state.entries,
  keys: (state: State): any[] => state.keys,
  type: (state: State): {} => state.type
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
